<div class="video-thumbnail-grid">
  @if (showThumbnailBlock()) {
  <div class="thumbnail-container cursor-pointer hover:ring-2 hover:ring-primary hover:ring-inset rounded-lg"
    [class]="videoFormat && videoFormat === 1 ? 'video-landscape' : 'video-portrait'">
    <img [src]="getDisplaySrc()" (error)="onImgError()" alt="Video Thumbnail"
      class="aspect-9/16 w-full h-full object-cover thumbnail-img" />
  </div>
  }

  @if (showLoadingSkeleton()) {
  <div
    class="thumbnail-container"
    [class]="videoFormat && videoFormat === 1 ? 'video-landscape' : 'video-portrait'">
    <div class="absolute inset-0 bg-neutral-quaternary rounded-lg"></div>
    <div class="absolute inset-0 flex items-center justify-center">
      <div class="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
          class="w-5 h-5 text-white/20 translate-x-0.5" aria-hidden="true">
          <path d="M8 5.14v14l11-7-11-7z" />
        </svg>
      </div>
    </div>
    <div class="absolute bottom-0 left-0 right-0 p-3 space-y-2">
      <div class="h-2 rounded-full bg-white/10 w-3/4"></div>
      <div class="h-2 rounded-full bg-white/10 w-1/2"></div>
    </div>
    <div class="skeleton-shimmer rounded-lg"></div>
  </div>
  }

  @if (showErrorState()) {
  <div class="thumbnail-container" [class]="videoFormat && videoFormat === 1 ? 'video-landscape' : 'video-portrait'">
    <img [src]="placeholderImage" alt="Video Thumbnail" class="aspect-9/16 w-full h-full object-cover thumbnail-img" />
  </div>
  }
</div>
